<template>
  <div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      style="margin-top: 25px"
    >
      <h2>Machine Template Management</h2>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <v-divider></v-divider>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="machine_template_list"
          :loading="table_loading"
          loading-text="Loading... Please wait"
          :mobile-breakpoint="0"
          :search="search"
          item-key="template_id"
          @click:row="view_machine_template"
          :show-select="true"
          v-model="selected_machine_template_list"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search Template"
                  single-line
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <div v-if="isEditor">
                <v-btn
                  depressed
                  color="blue"
                  dark
                  style="text-transform: capitalize"
                  class="mr-5"
                  @click="delete_machine_template"
                  v-if="selected_machine_template_list.length > 0"
                >
                  <v-icon left dark> mdi-close </v-icon>
                  Delete
                </v-btn>

                <v-btn
                  depressed
                  color="primary"
                  dark
                  style="text-transform: capitalize"
                  @click="create_machine_template"
                >
                  <v-icon left dark> mdi-plus </v-icon>
                  Create Machine Template
                </v-btn>
              </div>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      headers: [
        {
          text: "Template Name",
          value: "machine_template_name",
          sortable: true,
          divider: true,
        },
        {
          text: "Machine Type",
          value: "machine_type",
          sortable: true,
          divider: true,
        },
        // { text: "Tray and Slot", value: "tray_and_slot", sortable: true, divider: true },
        {
          text: "Number of Products",
          value: "number_of_products",
          sortable: true,
          divider: true,
        },
      ],
      selected_machine_template_list: [],
      machine_template_list: [],
      table_loading: false,
      search: "",
      current_user_company_doc_id: "",
      isEditor: false,
    };
  },
  methods: {
    async delete_machine_template() {
      var template_list = [];
      this.selected_machine_template_list.forEach((template) => {
        template_list.push(template.template_id);
      });
      this.show_close_loading("show", "Removing");
      var response = await this.send_http_request("deleteMachineTemplates", {
        template_list: template_list,
      });
      this.show_close_loading("close");
      if (response.data.status == "OK") {
        this.selected_machine_template_list = [];
        this.show_snack_bar("success", "Template Removed");
        this.load_machine_template();
      } else {
        this.show_snack_bar("error", "Something went wrong");
      }
    },
    view_machine_template(template) {
      this.$router
        .push({
          name: "MachineTemplateDetailScreen",
          params: { id: template.template_id },
        })
        .catch((err) => {});
    },
    load_machine_template() {
      this.table_loading = true;
      this.send_http_request("getAllMachineTemplateWithCompanyID", {
        company_doc_id: this.current_user_company_doc_id,
      })
        .then((response) => {
          this.table_loading = false;
          if (response.data.status == "OK") {
            this.machine_template_list = response.data.result;
          }
        })
        .catch((error) => {
          this.table_loading = false;
          console.log(error);
        });
    },
    create_machine_template() {
      this.$router
        .push({ name: "MachineTemplateDetailScreen", params: { id: "create" } })
        .catch((err) => {});
    },
  },
  mounted() {
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    this.load_machine_template();
    this.isEditor =
      this.current_user_company_doc_id == "" ||
      (this.current_user_company_doc_id != "" &&
        (this.current_user_permission.includes("N4sA8oghdJlrrsG1A8Ry") ||
          this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")));
  },
  created() {
    this.current_user_permission = this.$store.getters.getUserRoleList;
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    if (this.current_user_company_doc_id != "") {
      if (
        !this.current_user_permission.includes("N4sA8oghdJlrrsG1A8Ry") &&
        !this.current_user_permission.includes("oS6LYQsmZ98ZsGx5ZItZ") &&
        !this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")
      ) {
        this.$router.push({ name: "HomeScreen" }).catch((err) => {});
      }
    }
    // Update store
    var payload = {
      headerType: "needHeader",
      currentPage: "MachineTemplateScreen",
    };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style>
</style>